export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class ConversationNotFoundError extends Error {
  override readonly name = 'ConversationNotFoundError';
  constructor() {
    super('Conversation not found');
  }
}

export class InvalidAssistantInputError extends Error {
  override readonly name = 'InvalidAssistantInputError';
  constructor(message = 'Invalid assistant input') {
    super(message);
  }
}

export class ProposalNotFoundError extends Error {
  override readonly name = 'ProposalNotFoundError';
  constructor() {
    super('Proposal not found');
  }
}

/** The proposal was already saved or discarded, possibly from another tab. */
export class ProposalNotPendingError extends Error {
  override readonly name = 'ProposalNotPendingError';
  constructor() {
    super('Proposal is no longer pending');
  }
}

/** The conversation already holds as many pending photos as a message may carry. */
export class AttachmentLimitError extends Error {
  override readonly name = 'AttachmentLimitError';
  constructor() {
    super('Attachment limit reached');
  }
}

/** The photo was already sent, removed, or belongs to another conversation. */
export class AttachmentNotFoundError extends Error {
  override readonly name = 'AttachmentNotFoundError';
  constructor() {
    super('Attachment not found');
  }
}

export type AssistantError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | ConversationNotFoundError
  | ProposalNotFoundError
  | ProposalNotPendingError
  | AttachmentLimitError
  | AttachmentNotFoundError
  | InvalidAssistantInputError;
